<template>
  <div>
    <p>
      <strong class="registration-title">{{ $t('registration.info.title') }}</strong>
      <br />
      <span v-html="$t('registration.info.title.link', { instagramLink, tgLink })"></span>
    </p>
    <p>
      <strong>{{ $t('registration.info.subtitle') }}</strong>
      <br />
      <span v-html="$t('registration.info.subtitle.link', { supportLink })"></span>
    </p>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      instagramLink: 'instagram.com/capusta.space',
      tgLink: 't.me/capusta.space',
      supportLink: 'support@capusta.space',
    };
  },
};
</script>

<style lang="sass" scoped>
  div
    position: relative
    overflow-y: auto

    > p
      margin: 1.24rem
      text-align: left
      color: #585858

      &:first-of-type
        margin-top: 0

      &:last-of-type
        margin-bottom: 0

      strong
        display: inline-block
        margin-bottom: 1.24rem
        color: #000000

      &::v-deep a

        #{theme('eclipse')} &
          color: #2F80ED

        #{theme('obsidian')} &
          color: #2F80ED

  .registration-title
    margin-right: 24px
</style>
